module.exports = __webpack_public_path__ + "img/mp.e5069541.svg";